import ServiceExec from '@/common/utils/ServiceExec';
import { admin_orderAPI, admin_storeAPI, myPageAPI } from '@/common/service/ApiList';
import {
  createLocalChatUiFixture,
  isLocalChatUiFixtureEnabled,
  isLocalChatUiFixtureOrderNo,
  updateLocalChatUiFixtureOrderState
} from '@/views/chat/__fixtures__/chatUiFixture';

export default {
  async fetchOrderList({ commit, state }, payload) {
    // if (payload.page) commit('initList');

    const { page, totalPage, limit } = state;

    if (page > totalPage) return;
    const { status, data } = await ServiceExec.get(admin_orderAPI.order_list, {
      page,
      ...payload
    });

    if (status !== 200) return;
    const { pageInfo, list } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  async fetchOrderRank({ commit, state }, payload) {
    if (payload.page) commit('initList');

    const { page, totalPage, limit } = state;
    payload.page = page;
    const { status, data } = await ServiceExec.get(admin_orderAPI.order_rank, payload);

    if (status !== 200 || !data) return;
    const { pageInfo, list } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', data ?? []);
  },

  FETCH_ORDER_DETAIL: async ({ commit }, orderNo) => {
    const { status, data } = await ServiceExec.get(myPageAPI.order_detail(orderNo));
    if (status !== 200) return;

    const store = await ServiceExec.get(admin_storeAPI.my_shop_detail(data.storeNo));
    data.store = store.data;
    commit('setDetail', data);
  },

  CHANGE_ORDER_STATE: async (
    { state, commit, rootGetters },
    params = {
      orderNo: 0,
      storeUserNo: '',
      userNo: '',
      orderState: '',
      nameKr: '',
      nameVn: '',
      nameEn: '',
      orderManageNo: null,
      duration: null,
      cancelReason: null
    }
  ) => {
    if (isLocalChatUiFixtureEnabled() && isLocalChatUiFixtureOrderNo(params.orderNo)) {
      // LOCAL UI FIXTURE: update retained fixture/Vuex state before any real order API write.
      const wasUpdated = updateLocalChatUiFixtureOrderState(params.orderNo, params.orderState);
      if (!wasUpdated) return false;

      const currentUser = rootGetters['user/getUserData'] ?? {};
      const fixture = createLocalChatUiFixture(currentUser);
      const orderStatePayload = {
        orderNo: Number(params.orderNo),
        orderState: params.orderState
      };

      commit('chat/setRoomOrderState', orderStatePayload, { root: true });
      commit('chat/setLobbyOrderState', orderStatePayload, { root: true });
      commit('chat/setBubbleCounts', fixture.bubbleCounts, { root: true });
      commit('order/setMyOrderState', orderStatePayload, { root: true });
      return true;
    }

    const { status, data } = await ServiceExec.patch(admin_orderAPI.change_state, params);
  }
};
